import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { INDUSTRIES, PRODUCTS } from "@/data/content";
import { ProductIcon } from "@/lib/icons";
import { Section } from "@/components/shared";
import SolutionBuilder from "@/components/SolutionBuilder";

const Industries = () => {
  const { t, pick } = useLanguage();
  return (
    <div data-testid="industries-page">
      <Section eyebrow={t("industriesPage.eyebrow")} title={t("industriesPage.title")} sub={t("industriesPage.sub")} className="pt-20 sm:pt-28 grid-bg">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind) => (
            <Link
              key={ind.slug}
              to={`/industries/${ind.slug}`}
              data-testid={`industry-card-${ind.slug}`}
              className="card-surface card-surface-hover rounded-3xl p-6 border border-slate-800/80 hover:border-indigo-500/50 group flex flex-col"
            >
              <span className="w-11 h-11 rounded-2xl bg-indigo-500/15 flex items-center justify-center mb-4">
                <ProductIcon name={ind.icon} className="w-5 h-5 text-indigo-400" />
              </span>
              <h3 className="text-lg font-semibold font-heading text-white mb-2">{pick(ind.name)}</h3>
              <p className="text-xs text-slate-400 leading-relaxed mb-5 flex-1">{pick(ind.desc)}</p>
              <div className="flex flex-wrap gap-1.5 mb-4">
                {ind.stack.slice(0, 3).map((s) => {
                  const p = PRODUCTS.find((x) => x.slug === s);
                  return p ? <span key={s} className={`text-[10px] font-mono2 px-2 py-0.5 rounded-full ${p.accent.badge}`}>{p.short}</span> : null;
                })}
                {ind.stack.length > 3 && <span className="text-[10px] text-slate-500 px-1">+{ind.stack.length - 3}</span>}
              </div>
              <span className="inline-flex items-center gap-2 text-xs font-semibold text-indigo-400 group-hover:gap-3 transition-all">
                {t("common.learnMore")} <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          ))}
        </div>
      </Section>

      <Section eyebrow={t("builder.eyebrow")} title={t("builder.title")} className="bg-[#05070B] pt-0">
        <SolutionBuilder />
      </Section>
    </div>
  );
};

export default Industries;
